export default "//static.tradera.net/touchweb/static/output/images/push-splash-icon.28d4b79a.svg";